module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-field",
    attrs: {
      "id": "custom-select"
    }
  }, [_vm._t("label"), _vm._v(" "), _c('div', {
    staticClass: "select-wrapper"
  }, [_c('select', {
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_vm._t("options")], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a6f4130!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/inputs/Select.vue
// module id = 18
// module chunks = 0